import PropTypes from "prop-types";
import { Chip, Typography } from "@material-tailwind/react";
import { useState } from "react";
import "./IndividualExperience.css";

const IndividualExperience = ({
  from,
  to,
  company,
  position,
  type,
  description,
  stack,
  animationDelay = 0,
}) => {
  const delayStyle = {
    animationDelay: `${animationDelay * 0.1}s`,
  };

  // Company logo configuration - text-based by default
  // To use images, place files in public/company-logos/ folder
  const getCompanyLogoConfig = (companyName) => {
    const configs = {
      "KLASS Engineering & Solutions": {
        text: "KE",
        color: "#3b82f6",
        bgColor: "#dbeafe",
        imageFile: "klass.png"
      },
      "Singapore Management University": {
        text: "SMU",
        color: "#6366f1",
        bgColor: "#e0e7ff",
        imageFile: "smu.png"
      },
      "Accenture (Southeast Asia)": {
        text: "A",
        color: "#06b6d4",
        bgColor: "#cffafe",
        imageFile: "accenture.png"
      },
      "Government of Singapore Investment Corporation (GIC)": {
        text: "GIC",
        color: "#8b5cf6",
        bgColor: "#ede9fe",
        imageFile: "gic.png"
      },
      "TikTok": {
        text: "TT",
        color: "#ec4899",
        bgColor: "#fce7f3",
        imageFile: "tiktok.png"
      }
    };
    return configs[companyName] || {
      text: companyName.charAt(0),
      color: "#64748b",
      bgColor: "#f1f5f9"
    };
  };

  const logoConfig = getCompanyLogoConfig(company);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="timeline-item" style={delayStyle}>
      <div className="timeline-logo">
        {logoConfig.imageFile && !imageError ? (
          <div className="company-logo company-logo-image">
            <img
              src={`/company-logos/${logoConfig.imageFile}`}
              alt={company}
              className="logo-image"
              onError={() => setImageError(true)}
            />
          </div>
        ) : (
          <div
            className="company-logo"
            style={{ backgroundColor: logoConfig.bgColor, color: logoConfig.color }}
          >
            <span className="logo-text">{logoConfig.text}</span>
          </div>
        )}
      </div>

      <div className="timeline-content">
        <div className="timeline-date">
          <Typography variant="small" className="date-text">
            {from} - {to}
          </Typography>
        </div>

        <div className="timeline-details">
          <Typography variant="h4" className="company-name">
            {company}
          </Typography>
          <Typography variant="h6" className="position-title">
            {position}
          </Typography>
          <Typography className="employment-type">
            {type}
          </Typography>
          <Typography className="experience-description">
            {description}
          </Typography>

          {stack.length > 0 && (
            <div className="stack-container">
              <div className="stack-chips">
                {stack.map((tech, index) => (
                  <Chip
                    key={index}
                    variant="outlined"
                    size="sm"
                    value={tech}
                    className="stack-chip"
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

IndividualExperience.propTypes = {
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  stack: PropTypes.arrayOf(PropTypes.string).isRequired,
  animationDelay: PropTypes.number,
};

export default IndividualExperience;
